import { SR_API_ACTION_HOUSEHOLD_APPLICATION_PROCESS_CHARGE } from 'api/actionTypes';

export default async function processCharge(
  { state, apiClient },
  { householdApplicationId, listingId, source, onSuccess },
) {
  return apiClient.postWithState({
    action: SR_API_ACTION_HOUSEHOLD_APPLICATION_PROCESS_CHARGE,
    state: state,
    onSuccess: ({ stripeCustomerId }) => {
      state.set(['currentUser', 'stripeCustomerId'], stripeCustomerId);

      if (onSuccess) {
        onSuccess();
      }
    },
    payload: {
      source,
      listingId,
      householdApplicationId,
    },
  });
}
